export const formatMonetaryAmount = (amount, currencyCode) => {
  const numericAmount = Number(amount);
  const groupedAmount = Number.isNaN(numericAmount)
    ? "0.00"
    : numericAmount.toLocaleString(currencyCode === "INR" ? "en-IN" : "en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

  return currencyCode ? `${currencyCode} ${groupedAmount}` : groupedAmount;
};
